import { create } from "zustand";

type Route = {
  path: string;
};
type NavigationState = {
  routes: Route[];
  pushRoute: (route: Route) => void;
  dataByPath: Record<string, unknown>;
  setData: (path: string, data: unknown) => void;
};

export const useNavigationStore = create<NavigationState>((set) => ({
  dataByPath: {},
  routes: [],
  pushRoute: (route) =>
    set((s) => {
      const last = s.routes.at(-1);
      if (last?.path === route.path) return s;
      return { routes: [...s.routes, route] };
    }),
  setData: (path, data) =>
    set((s) => ({ dataByPath: { ...s.dataByPath, [path]: data } })),
}));
